const createNumberRenderer = (format?: string) => (value: number) => {
  if (isNaN(value)) {
    return '0'
  }

  if (!format) {
    return value.toString()
  }

  const options: any = {}

  switch (format) {
    case 'COMMAS':
      options.maximumFractionDigits = 20
      break

    case 'PERCENT':
      return `${value.toString()}%`

    case 'NUMBER':
      return value.toString()

    default:
      options.style = 'currency'
      options.currency = format
      options.currencyDisplay = 'symbol'
  }

  return value.toLocaleString('en-US', options)
}

export default createNumberRenderer
